<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col cols="12" md="7">
        <v-data-iterator
          :items="buttonList"
          :options.sync="options"
          :server-items-length="totalItems"
          :search="search"
          @page-count="pageCount = $event"
          hide-default-footer
        >
          <template v-slot:header>
            <v-container fluid>
              <v-row class="justify-between align-center">
                <v-col cols="12" class="mb-5">
                  <v-text-field
                    filled
                    rounded
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <template v-slot:default="props">
            <v-row>
              <v-col
                v-for="item in props.items"
                :key="item.name"
                cols="12"
                md="6"
              >
                <v-card class="shadow-2">
                  <v-list
                    v-ripple
                    two-line
                    max-width="350px"
                    class="transparent"
                    style="cursor: pointer"
                  >
                    <v-list-item @click="letsCall(item.token)">
                      <v-list-item-avatar size="40" tile>
                        <v-avatar
                          size="40"
                          :color="
                            $vuetify.theme.dark
                              ? 'blue-grey darken-4'
                              : 'blue-grey lighten-5'
                          "
                        >
                          <v-img
                            v-if="item.url_image"
                            :src="item.url_image"
                            alt="Avatar del usuario"
                          ></v-img>
                          <v-icon color="blue-grey" v-else>mdi-account</v-icon>
                        </v-avatar>
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title
                          class="primary--text text--darken-1 font-weight-medium"
                          v-html="item.name"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-html="item.to_respond"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-col>
            </v-row>
          </template>

          <!-- <template v-slot:footer>
        <v-row class="mt-2" align="center" justify="center">
          <span class="grey--text">Items per page</span>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                dark
                text
                color="primary"
                class="ml-2"
                v-bind="attrs"
                v-on="on"
              >
                {{ itemsPerPage }}
                <v-icon>mdi-chevron-down</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(number, index) in itemsPerPageArray"
                :key="index"
                @click="updateItemsPerPage(number)"
              >
                <v-list-item-title>{{ number }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>

          <v-spacer></v-spacer>

          <span
            class="mr-4
            grey--text"
          >
            Page {{ page }} of {{ numberOfPages }}
          </span>
          <v-btn
            fab
            dark
            color="blue darken-3"
            class="mr-1"
            @click="formerPage"
          >
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <v-btn fab dark color="blue darken-3" class="ml-1" @click="nextPage">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </template> -->
        </v-data-iterator>
      </v-col>

      <v-col cols="12" md="6">
        <!-- <v-pagination
          circle
          :total-visible="5"
          color="primary"
          v-model="currentPage"
          :length="totalPages"
          @input="handlePageChange"
        ></v-pagination> -->
        <v-pagination
          v-if="pageCount > 1"
          circle
          color="primary"
          v-model="options.page"
          :length="pageCount"
          total-visible="5"
        ></v-pagination>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";

export default {
  data() {
    return {
      isLoading: false,
      search: "",
      // For pagination
      totalItems: 0,
      options: {
        page: 1,
        itemsPerPage: 15,
      },
      pageCount: 1,
      // End for pagination
      buttonList: [],
    };
  },

  watch: {
    options: {
      handler() {
        this.getButtons();
      },
      deep: true,
    },
  },

  created() {
    this.getButtons();
  },

  methods: {
    async getButtons() {
      this.isLoading = true;

      const { page, itemsPerPage } = this.options;

      await PbxHttpClient.get(`/admin/call_button`, {
        params: { page, itemPerPage: itemsPerPage },
      })
        .then((res) => {
          this.buttonList = res.data.data;
          this.totalItems = res.data.total;
          this.pageCount = res.data.last_page;
        })
        .catch((error) => {
          // console.error(error);
          this.$snotify.error("Hubo un error en la consulta.", "Error");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    letsCall(token) {
      window.open(
        `${process.env.VUE_BUTTON_CALLS_URL}/public?token=${token}`,
        "_blank"
      );
    },

    // nextPage() {
    //   if (this.page + 1 <= this.numberOfPages) this.page += 1;
    // },
    // formerPage() {
    //   if (this.page - 1 >= 1) this.page -= 1;
    // },
    // updateItemsPerPage(number) {
    //   this.itemsPerPage = number;
    // },
  },
};
</script>
